import React from 'react';

export default () => (
  <div>
    <h1>Now loading...</h1>
  </div>
);
